// extracted by mini-css-extract-plugin
export default {"container":"LanfingPage_container__pucjM"};